import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateAPublicExam extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PublicExam/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAPublicExam extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PublicExam/GetBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetAllPublicExams extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PublicExam/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class DeleteAPublicExam extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PublicExam/DeleteBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  CreateAPublicExam,
  GetAPublicExam,
  GetAllPublicExams,
  DeleteAPublicExam,
};
